import { render, staticRenderFns } from "./UploadFileButton.vue?vue&type=template&id=1498b672&scoped=true"
import script from "./UploadFileButton.vue?vue&type=script&lang=js"
export * from "./UploadFileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1498b672",
  null
  
)

export default component.exports